// 退换货-基础信息
const ReturnFactoryForm1 = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'150px',
    showSlot:true,
    formData:{},
    formField:[
        // {
        //     name:'returnExchange.type', //类型
        //     key:'type',
        //     type:'select',  
        //     required:true,
        //     width:'420px',
        //     placeholder:'base.select',
        //     optionToLocale:true,
        //     options:[]
        // },
        {
            name:'returnExchange.status', // 状态
            key:'status',
            type:'select',   
            // allowClear:true,
            disabled:true,
            required:true,
            width:'420px',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {
                    label:'returnExchange.returningFactory',
                    value:1,
                },
            ]
        },
        {
            name:'returnExchange.source', // 来源
            key:'source',
            type:'input',   
            disabled:true,
            width:'420px',
        },
    ]
}

const ReturnFactoryForm2 = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'150px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'returnExchange.returnFactoryReasonType', // 返修原因类型
            key:'back_reason_type', 
            type:'select',
            required:true,
            width:'420px',
            placeholder:'base.select',
        },
        {
            name:'returnExchange.returnFactoryReason', // 返修原因
            key:'back_reason',
            type:'textarea',   
            allowClear:true,
            required:true,
            showWordLimit:true,
            maxLength:150,
            width:'420px',
            placeholder:'base.input',
        },
        {
            name:'returnExchange.backTimestamp', // 返修退回时间
            key:'back_timestamp',
            type:'date',   
            allowClear:true,
            required:true,
            show:true,
            width:'420px',
            placeholder:'base.selecteDate',
        },
        {
            name:'returnExchange.courierType', // 返修退回物流公司
            key:'courier_type',
            type:'select',   
            allowClear:true,
            required:true,
            // disabled:true,
            width:'420px',
            placeholder:'base.select',
            options:[]
        },
        {
            name:'returnExchange.courierNo', // 返修退回物流单号
            key:'courier_no',
            type:'input',   
            allowClear:true,
            required:true,
            disabled:true,
            width:'420px',
            placeholder:'base.input',
        },
        {
            name:'returnExchange.ibsVerificationType', // IBS验证方案类型
            key:'ibs_verification_type',
            type:'select',
            width:'420px',
            placeholder:'base.select',
            options:[]
        },
        {
            name:'returnExchange.ibsVerificationPlan', // IBS验证方案描述
            key:'ibs_verification_plan', 
            type:'textarea',   
            allowClear:true,
            showWordLimit:true,
            maxLength:250,
            width:'420px',
            placeholder:'base.input',
        },
    ]
}

const ReturnFactoryForm3 = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'150px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'returnExchange.returnFactoryTimestampPlan', // 返修寄出计划发出时间（换货需要填）
            key:'swap_timestamp_plan',
            type:'date',   
            allowClear:true,
            required:true,
            width:'420px',
        },
        {
            name:'returnExchange.returnFactoryCourierType', // 返修寄出物流公司
            key:'swap_courier_type',
            type:'select',   
            allowClear:true,
            // required:true,
            // disabled:true,
            width:'420px',
            placeholder:'base.select',
            options:[]
        },
        {
            name:'returnExchange.returnFactoryCourierNo', // 返修寄出物流单号
            key:'swap_courier_no',
            type:'input',   
            allowClear:true,
            disabled:true,
            // required:true,
            width:'420px',
            placeholder:'base.input',
        },
        
    ]
}

ReturnFactoryForm1.formField.forEach(item=>{
    ReturnFactoryForm1.formData[item.key] = ''
})

ReturnFactoryForm2.formField.forEach(item=>{
    ReturnFactoryForm2.formData[item.key] = ''
})

ReturnFactoryForm3.formField.forEach(item=>{
    ReturnFactoryForm3.formData[item.key] = ''
})

export {
    ReturnFactoryForm1,
    ReturnFactoryForm2,
    ReturnFactoryForm3,
}